import React, { RefAttributes, PropsWithChildren, FunctionComponent } from 'react';
import { Typography, TypographyProps } from '@mui/material';

import { cn, ClassName, ComponentWrapperProps } from '../../utils';
import styles from './index.module.scss';


type Ellipsis = {
    ellipsis?: boolean;
};

const applyEllipsis = (ellipsis?: boolean) => ellipsis && styles.ellipsis;

export type LabelProps = Ellipsis & {
    weight?: 'regular' | 'medium' | 'bold';
    textSize: '48' | '40' | '36' | '32' | '28' | '24' | '20';
};

export const Label = <PComponent extends PropsWithChildren<ClassName>>({
    component,
    componentRef,
    weight,
    textSize,
    ellipsis, // LabelProps
    className,
    ...props // PComponent
}: ComponentWrapperProps<PComponent, LabelProps>) =>
    React.createElement(component, {
        ...props,
        ref: componentRef,
        className: cn(
            styles.label,
            styles[weight],
            styles[`label-${textSize}`],
            applyEllipsis(ellipsis),
            className,
        ),
    } as any as PComponent & RefAttributes<any>);

type TextProps = Ellipsis & {
    textSize: '40' | '36' | '32' | '28' | '24' | '20' | '18' | '16' | '14' | '12' | '10';
    weight?: 'regular' | 'medium' | 'bold';
};

export const Text = <PComponent extends PropsWithChildren<ClassName>>({
    component,
    componentRef,
    textSize,
    ellipsis,
    weight, // TextProps
    className,
    ...props // PComponent
}: ComponentWrapperProps<PComponent, TextProps>) =>
    React.createElement(component, {
        ...props,
        ref: componentRef,
        className: cn(
            styles.text,
            styles[weight],
            styles[`text-${textSize}`],
            applyEllipsis(ellipsis),
            className,
        ),
    } as any as PComponent & RefAttributes<any>);

export const linkAnchorClass = styles.linkContent;

export const Note: FunctionComponent<ClassName> = ({ className, children }) => (
    <span className={cn(styles.note, className)}>{children}</span>
);

export { Typography };
export type { TypographyProps };
